import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toThemeClass } from "../../utils/toThemeClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toViewClass } from "../../utils/toViewClass.js";
const Message = memo(({ className, children, intent, size, flow, distinction, type, lifted, action }) => {
  const prefix = useClassNamePrefix();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        `${prefix}message`,
        toThemeClass(intent, intent),
        toEnumViewClass(size),
        toEnumViewClass(distinction),
        toViewClass("lifted", lifted),
        toEnumViewClass(flow),
        className
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: `${prefix}message-content`, children }),
        action && /* @__PURE__ */ jsx("div", { className: `${prefix}message-action`, children: action })
      ]
    }
  );
});
Message.displayName = "Message";
export {
  Message
};
//# sourceMappingURL=Message.js.map
